import { useContext } from "react";
import { PackageWithLeaguesStoreContext } from "../../components/package-with-leagues-store-provider";

export const usePackageWithLeaguesStoreApi = () => {
  const store = useContext(PackageWithLeaguesStoreContext);
  if (!store) throw new Error("PackageWithLeaguesStoreProvider is missing");
  return store;
};

export default usePackageWithLeaguesStoreApi;
